import $ from 'jquery';

  $(function() {
    $('.cta-show-more').on('click', function(){
        $('.event-desc__hide').toggle("slide");
        if ($('.cta-show-more').find('.cta--text').text() == "Show More") {
          $(this).find('.cta--text').text("Show Less");
          $(this).find('.cta--down-arrow-icon').css('transform', 'rotate(180deg)');
        } 
        else {
          $(this).find('.cta--text').text("Show More");
          $(this).find('.cta--down-arrow-icon').css('transform', 'rotate(0deg)');
        }
    });  
  });


// WEBPACK FOOTER //
// ./components/cwm-event-description/scripts/cwm-event-description.js